import React, { useEffect, useState, useMemo } from 'react'
import { Paper, Typography, IconButton } from '@mui/material';
import { contentTableRowDetailed } from 'pages/detailed-consultation/helpers/contentTableRowDetailed';
import { useParams } from 'react-router-dom';
import { useTablaTrazabilidad } from 'pages/detailed-consultation/hooks/useTablaTrazabilidad';
import Images from 'shared/assets/index'
import { CustomPagination, Spinner } from 'shared/components';
import { DataGrid, GridToolbar, esES } from '@mui/x-data-grid';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import '../styles/_tableDetaildConsultation.scss'

export const TablaTrazabilidad = () => {
    const { idDocument } = useParams();
    const { callGetEventTrace, traceabilityDetails, isLoading } = useTablaTrazabilidad();
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(null);

    useEffect(() => {
        callGetEventTrace(idDocument || "")
    },[])

    // Ordenar los datos según el estado de sortConfig
    const sortedRows = useMemo(() => {
        if (!sortConfig) return traceabilityDetails;
        const sorted = [...traceabilityDetails].sort((a, b) => {
            let aValue = a[sortConfig.key] as any;
            let bValue = b[sortConfig.key] as any;
            if (aValue === undefined || aValue === null) aValue = '';
            if (bValue === undefined || bValue === null) bValue = '';
            if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });
        return sorted;
    }, [traceabilityDetails, sortConfig]);

    // Cambiar el orden
    const handleSort = (key: string) => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        } else if (sortConfig && sortConfig.key === key && sortConfig.direction === 'desc') {
            setSortConfig(null);
            return;
        }
        setSortConfig({ key, direction });
    };

    // Icono de orden
    const getSortIcon = (key: string) => {
        if (!sortConfig || sortConfig.key !== key) {
            return <KeyboardArrowDownIcon fontSize="small" />;
        }
        return sortConfig.direction === 'asc'
            ? <KeyboardArrowUpIcon fontSize="small" />
            : <KeyboardArrowDownIcon fontSize="small" />;
    };

    // Personalizar los headers
    const columns = contentTableRowDetailed.map(col => ({
        ...col,
        renderHeader: () => (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                    userSelect: 'none',
                    background: '#f8fafc',
                    border: 0,
                    color: 'rgba(var(--general-color-r), var(--general-color-g), var(--general-color-b), 1)',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    padding: '8px 6px',
                    transition: 'all 0.3s ease',
                    textTransform: 'capitalize',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                }}
                onClick={() => handleSort(col.field)}
            >
                <span>{col.headerName}</span>
                <IconButton 
                    size="small"
                    style={{
                        cursor: 'pointer',
                        marginLeft: '6px',
                        padding: '2px',
                        borderRadius: '4px',
                        transition: 'all 0.2s ease-in-out',
                        background: 'transparent',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {getSortIcon(col.field)}
                </IconButton>
            </div>
        ),
        sortable: false // Desactiva el sort nativo de MUI
    }));

    return (
        <Paper className={'containerTableResults'} data-testid='container_table_results'>
            <div className='containerTitleCard'>
                <img src={Images.iconoCheck} alt="" />
                <Typography className='titleCard'>Detalle de Trazabilidad de Factura</Typography>
            </div>
            <DataGrid
                rows={sortedRows}
                columns={columns as any}
                className={'tableResultsData'}
                data-testid="datagrid-history"
                disableColumnFilter
                disableColumnSelector
                disableDensitySelector
                disableColumnMenu={true}
                hideFooterSelectedRowCount={true}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                initialState={{
                    pagination: { paginationModel: { pageSize: 25 } },
                  }}
                pagination
                pageSizeOptions={[25,50,75,100]}
                getRowHeight={() => 100}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                    },
                }}
                slots={{ 
                    toolbar: GridToolbar, 
                    pagination: CustomPagination, 
                }}
            />
            {(isLoading) && <Spinner/>}
        </Paper> 
    )
}
